import { render, staticRenderFns } from "./20welcomSheng.vue?vue&type=template&id=46e7d88a&scoped=true&"
import script from "./20welcomSheng.vue?vue&type=script&lang=js&"
export * from "./20welcomSheng.vue?vue&type=script&lang=js&"
import style0 from "./20welcomSheng.vue?vue&type=style&index=0&id=46e7d88a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e7d88a",
  null
  
)

export default component.exports